import React from 'react';
import { useSelector } from 'react-redux';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Input, EAA_Add_Btn } from '~/components/EditAndAddItem';

const emptyBody = {
  break_item: '',
  multi_num: '',
  percent_num: '',
};

const App = props => {
  const { titleWidth, disabled, checkSubChange, changeData, data } = props;
  const ACDefaultList = useSelector(state => state.data.ACDefaultList);
  const ary = data.sub3 || [];
  if (ary.length === 0)ary.push({ ...emptyBody });

  const saveSub = dataAry => {
    changeData({ label: 'sub3', data: dataAry });
  };

  const addRow = () => {
    ary.push({ ...emptyBody });
    saveSub(ary);
  };

  const delRow = n => {
    ary.splice(n, 1);
    saveSub(ary);
  };

  const renderAry = [];
  for (let i = 0; i < ary.length; i++) {
    const isFirst = i === 0;
    const price = (data.performance_price || 0) * (ary[i].percent_num || 0) * (ary[i].multi_num || 0) / 100;
    renderAry.push(
      <EAA_Row key={`Page_Contract_sub3_${i}`}>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} text={isFirst ? '違約項目 (千萬元)' : ''} bol={isFirst} haveChange={checkSubChange(3, [emptyBody])} />
            <EAA_Select displayBorder disabled={disabled} list={ACDefaultList} value={ary[i].break_item} onChange={data => { ary[i].break_item = data; saveSub(ary); }} />
          </EAA_ItemContainer>
          {/* {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇進度' />} */}
        </EAA_Item>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width='auto' text='履保金額  X' />
            <EAA_Input style={{ maxWidth: 150, marginRight: 12 }} displayBorder disabled={disabled} type='number' hint='' value={ary[i].percent_num} onChange={data => { ary[i].percent_num = data; saveSub(ary); }} />
            <EAA_TitleText width='auto' text='% X' />
            <EAA_Input style={{ maxWidth: 150, marginRight: 12 }} displayBorder disabled={disabled} type='number' hint='' value={ary[i].multi_num} onChange={data => { ary[i].multi_num = data; saveSub(ary); }} />
            <EAA_TitleText width='auto' text='=' />
            <div style={{ flex: 1 }}>{price}</div>
            <EAA_Add_Btn disabled={disabled} del={i > 0} onClick={(i > 0) ? () => delRow(i) : () => addRow()} />
          </EAA_ItemContainer>
          {/* {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇進度' />} */}
        </EAA_Item>
      </EAA_Row>,
    );
  }
  return renderAry;
};
export default App;
